import React, { useState } from "react";

import IframeForm from "../../../../../containers/smart/camunda/IframeForm";
import { language } from "../../../../../language";
import Provider from "../../../../../Provider";
import GenericModal from "../../../../modal-closebtn/index";

const ModelerModalFormsPreview = ({ fetchGetFormListByIDLISTClear, forms }) => {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    //fetchGetFormListByIDLISTClear();
    setOpen(false);
  };

  const formData = {
    isSignatureTask: false,
    form: forms.map((item) => ({ [item.name]: item })),
    variables: {},
  };

  return (
    open && (
      <Provider>
        <GenericModal
          title={language.formsPreview}
          handleClose={handleClose}
          size="xl"
          bigHeight
          open={true}
        >
          {formData.form.length ? (
            <IframeForm formData={formData} onSubmit={() => null} previewMode />
          ) : null}
        </GenericModal>
      </Provider>
    )
  );
};

export default ModelerModalFormsPreview;
